import apiClient from '@/services/apiClient'

export default {
    /**
     * Registers a device's FCM token with the user account
     * @param {string} token - The FCM token to register
     * @returns {Promise} API response
     */
    async registerToken(token) {
        try {
            const response = await apiClient.post(
                '/notifications/register-token',
                {
                    token: token,
                }
            )
            return response
        } catch (error) {
            console.error('Error registering FCM token:', error)
            throw error
        }
    },

    /**
     * Removes a device's FCM token from the user account
     * @param {string} token - The FCM token to unregister
     * @returns {Promise} API response
     */
    async unregisterToken(token) {
        try {
            const response = await apiClient.post(
                '/notifications/unregister-token',
                {
                    token: token,
                }
            )
            return response
        } catch (error) {
            console.error('Error unregistering FCM token:', error)
            throw error
        }
    },

    /**
     * Enables or disables push notifications for a user
     * @param {boolean} enabled - true to enable notifications, false to disable
     * @returns {Promise} API response
     */
    async toggleNotifications(enabled) {
        try {
            const response = await apiClient.post('/notifications/toggle', {
                enabled: enabled,
            })
            return response
        } catch (error) {
            console.error('Error toggling notifications:', error)
            throw error
        }
    },

    /**
     * Subscribes one or all of a user's devices to a specific notification topic
     * @param {string} topic - The topic name to subscribe to
     * @param {string} [token] - Optional: specific FCM token to subscribe. If omitted, all user's tokens are subscribed
     * @returns {Promise} API response
     */
    async subscribeToTopic(topic, token = null) {
        try {
            const payload = { topic }
            if (token) {
                payload.token = token
            }

            const response = await apiClient.post(
                '/notifications/subscribe',
                payload
            )
            return response
        } catch (error) {
            console.error('Error subscribing to topic:', error)
            throw error
        }
    },

    /**
     * Unsubscribes one or all of a user's devices from a specific notification topic
     * @param {string} topic - The topic name to unsubscribe from
     * @param {string} [token] - Optional: specific FCM token to unsubscribe. If omitted, all user's tokens are unsubscribed
     * @returns {Promise} API response
     */
    async unsubscribeFromTopic(topic, token = null) {
        try {
            const payload = { topic }
            if (token) {
                payload.token = token
            }

            const response = await apiClient.post(
                '/notifications/unsubscribe',
                payload
            )
            return response
        } catch (error) {
            console.error('Error unsubscribing from topic:', error)
            throw error
        }
    },
}
